
// =======================================================
// 🌐 IDIOMAS DISPONIBLES
// =======================================================
export const LANGS = [
  { code: "es", flag: "🇪🇸", title: "Español" },
  { code: "en", flag: "🇺🇸", title: "English" },
  { code: "de", flag: "🇩🇪", title: "Deutsch" },
  { code: "fr", flag: "🇫🇷", title: "Français" },
  { code: "it", flag: "🇮🇹", title: "Italiano" },
  { code: "ru", flag: "🇷🇺", title: "Русский" }
];

// =======================================================
// 🌐 IDIOMA ACTUAL (DEFAULT)
// =======================================================
let currentLang = LANGS.find(l => l.code === "es");

// =======================================================
// 🔧 SETTER
// =======================================================
export function setLang(langCode) {
  const found = LANGS.find(l => l.code === langCode);
  if (found) {
    currentLang = found;
    console.warn("Idioma Seleccionado:", langCode);

    // 🔔 notificar a la UI
    langListeners.forEach(cb => {
      try { cb(langCode); } catch (e) {}
    });
  }
}

// =======================================================
// 📤 GETTERS
// =======================================================
export function getLang() {
  return currentLang;
}

export function getLangCode() {
  return currentLang.code;
}

export function getAllLangs() {
  return LANGS;
}



let langListeners = [];

export function onLangChange(cb) {
  if (typeof cb === "function") {
    langListeners.push(cb);
  }
}






// =======================================================
// 🧠 PAGINACIÓN DIVE LOGS (GLOBAL STATE)
// =======================================================

let divePagination = {
  currentOffset: 0,
  LIMIT: 10,
  hasMore: true,
  loading: false
};

let divePaginationListeners = [];


export function setDivePagination(newState = {}) {

  divePagination = {
    ...divePagination,
    ...newState
  };

  divePaginationListeners.forEach(cb => {
    try { cb(divePagination); } catch(e){}
  });
}


export function getDivePagination(){
  return divePagination;
}



export function resetDivePagination(){

  divePagination = {
    currentOffset: 0,
    LIMIT: 10,
    hasMore: true,
    loading: false
  };

  divePaginationListeners.forEach(cb => {
    try { cb(divePagination); } catch(e){}
  });
}



export function onDivePaginationChange(cb){
  if(typeof cb === "function"){
    divePaginationListeners.push(cb);
  }
}